import React from 'react'
import Flex from 'typescript-styled-flex'
import { Input, Slider, Switch } from './Switch'
import { ICheckboxProps } from './index'

function Checkbox({
  name,
  onClick,
  size = 1,
  onChange,
  value,
  small,
  className,
  onBlur,
  disabled,
  checkboxWrapperStyle,
  afterLabel = () => {},
  onFocus,
  inputRef,
                    inputStyle,
}: ICheckboxProps) {
  return (
    <Flex style={checkboxWrapperStyle} alignCenter={true}>
      <Switch size={size} small={small}>
        <Input
          size={size}
          name={name}
          ref={inputRef}
          style={inputStyle}
          type="checkbox"
          onClick={onClick}
          onChange={onChange}
          disabled={disabled}
          onFocus={onFocus}
          onBlur={onBlur}
          value={value}
          small={small}
          checked={value}
          className={className}
          data-cy={className}
        />
        <Slider style={inputStyle} size={size} small={small} />
      </Switch>
      {afterLabel({ value })}
    </Flex>
  )
}

export default Checkbox
